import classnames from "classnames";
import React, { useRef } from "react";

import { useOutsideAlerter } from "@utils/hooks/useOutsideAlerter";

import { FeatureToggleKeys } from "@services/featureToggles.services";

import "./featureSwitch.scss";
import { FeatureSwitchToggle } from "./featureSwitchToggle.component";
import { Button } from "@components/General/Button/button.component";

type FeatureSwitchComponentProps = {
    onToggle: (state?: boolean) => void;
    isOpen: boolean;
    features: Array<{ name: FeatureToggleKeys; value: boolean }>;
    onToggleFeature: (name: FeatureToggleKeys, value: boolean) => void;
    bottomControlsVisible: boolean;
};

const FeatureSwitchComponent = ({
    onToggle,
    isOpen,
    features,
    onToggleFeature,
    bottomControlsVisible,
}: FeatureSwitchComponentProps) => {
    const ref = useRef<HTMLDivElement | null>(null);

    useOutsideAlerter(() => {
        onToggle(false);
    }, ref);

    return (
        <div
            className={classnames(
                "feature-switch btn-group dropup",
                bottomControlsVisible && "feature-switch--bottomControlsVisible",
            )}
            ref={ref}
        >
            <Button
                type="button"
                color="warning"
                onClick={() => onToggle()}
                data-toggle="dropdown"
            >
                <i className="las la-sliders-h"></i>
            </Button>
            <div
                className={classnames("dropdown-menu feature-switch_menu", {
                    show: isOpen,
                })}
            >
                {features.map(feature => {
                    return (
                        <div key={feature.name} className="dropdown-item">
                            <FeatureSwitchToggle
                                name={feature.name}
                                value={feature.value}
                                onToggle={() =>
                                    onToggleFeature(
                                        feature.name,
                                        !feature.value,
                                    )
                                }
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export { FeatureSwitchComponent };
